module.exports = __webpack_public_path__ + "static/media/11_tn.c0bd7e97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/11_tn.jpg
// module id = 647
// module chunks = 0